import React, { useState, useEffect } from 'react';
import { Calendar, Menu, X } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Navigation = () => {
  const navigate = useNavigate();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMobileMenuOpen(false);
  };

  const navItems = [
    { label: 'Our Films', id: 'portfolio' },
    { label: 'Venues', route: '/venues' },
    { label: 'Packages', id: 'packages' },
    { label: 'Reviews', id: 'testimonials' },
    { label: 'FAQ', id: 'faq' },
  ];

  const handleNavClick = (item) => {
    if (item.route) {
      navigate(item.route);
      setIsMobileMenuOpen(false);
    } else {
      scrollTo(item.id);
    }
  };

  return (
    <nav
      data-testid="navigation"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled ? 'bg-black/95 backdrop-blur-md py-3 shadow-2xl' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            className="text-white font-serif text-xl sm:text-2xl font-semibold tracking-wide hover:text-gold transition-colors"
          >
            Wedding Video Essex
          </button>

          <div className="hidden lg:flex items-center gap-8">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavClick(item)}
                className="text-white/80 hover:text-white text-sm font-medium tracking-wide uppercase transition-colors"
              >
                {item.label}
              </button>
            ))}
            <button
              onClick={() => scrollTo('availability')}
              data-testid="nav-check-date-btn"
              className="bg-white/10 hover:bg-white/20 text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-300 flex items-center gap-2 border border-white/20"
            >
              <Calendar className="w-4 h-4" />
              Check Your Date
            </button>
            <button
              onClick={() => window.open('https://www.weddingvideo.co.uk/contact', '_blank')}
              data-testid="nav-enquire-btn"
              className="bg-gold hover:bg-gold-light text-black text-sm font-semibold px-5 py-2.5 rounded-full transition-all duration-300 hover:scale-105 pulse-ring"
            >
              Secure My Date
            </button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-white p-2"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 py-4 bg-black/95 backdrop-blur-md rounded-xl border border-white/10">
            {navItems.map((item) => (
              <button
                key={item.label}
                onClick={() => handleNavClick(item)}
                className="block w-full text-left px-6 py-3 text-white/80 hover:text-white hover:bg-white/5 text-sm uppercase tracking-wide"
              >
                {item.label}
              </button>
            ))}
            <div className="px-4 pt-3 flex flex-col gap-2">
              <button
                onClick={() => scrollTo('availability')}
                className="w-full bg-white/10 text-white text-sm font-semibold px-5 py-3 rounded-full transition-all flex items-center justify-center gap-2 border border-white/20"
              >
                <Calendar className="w-4 h-4" />
                Check Your Date
              </button>
              <button
                onClick={() => { window.open('https://www.weddingvideo.co.uk/contact', '_blank'); setIsMobileMenuOpen(false); }}
                className="w-full bg-gold text-black text-sm font-semibold px-5 py-3 rounded-full transition-all"
              >
                Secure My Date
              </button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;
